"use strict";

require("core-js/modules/es.array.reduce");

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("react"),
    t = require("styled-components"),
    n = require("lodash.orderby");

function o(e) {
  return e && "object" == typeof e && "default" in e ? e : {
    default: e
  };
}

var r = o(e),
    i = o(t),
    a = o(n),
    _l = function l() {
  return (_l = Object.assign || function (e) {
    for (var t, n = 1, o = arguments.length; n < o; n++) {
      for (var r in t = arguments[n]) {
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }
    }

    return e;
  }).apply(this, arguments);
};

function d(e, t) {
  var n = {};

  for (var o in e) {
    Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  }

  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var r = 0;

    for (o = Object.getOwnPropertySymbols(e); r < o.length; r++) {
      t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
    }
  }

  return n;
}

function s() {
  for (var e = 0, t = 0, n = arguments.length; t < n; t++) {
    e += arguments[t].length;
  }

  var o = Array(e),
      r = 0;

  for (t = 0; t < n; t++) {
    for (var i = arguments[t], a = 0, l = i.length; a < l; a++, r++) {
      o[r] = i[a];
    }
  }

  return o;
}

function c(e, t) {
  return Object.defineProperty ? Object.defineProperty(e, "raw", {
    value: t
  }) : e.raw = t, e;
}

var u, p, f;

function g(e, t, n, o) {
  return void 0 === o && (o = null), t ? o && "function" == typeof o ? o(e, t, n) : a.default(e, t, n) : e;
}

function h(e, t, n) {
  void 0 === e && (e = []), void 0 === n && (n = "id");
  var o = e.slice();
  return t[n] ? o.splice(o.findIndex(function (e) {
    return e[n] === t[n];
  }), 1) : o.splice(o.findIndex(function (e) {
    return e === t;
  }), 1), o;
}

function w(e, t) {
  return Math.ceil(e / t);
}

function v(e, t) {
  return Math.min(e, t);
}

(u = exports.Direction || (exports.Direction = {})).LTR = "ltr", u.RTL = "rtl", u.AUTO = "auto", (p = exports.Alignment || (exports.Alignment = {})).Left = "left", p.Right = "right", p.Center = "center", (f = exports.Media || (exports.Media = {})).SM = "sm", f.MD = "md", f.LG = "lg";

var m = function m() {
  return null;
};

function b(e, t) {
  void 0 === t && (t = []);
  var n = {};
  return t.length && t.forEach(function (t) {
    if (!t.when || "function" != typeof t.when) throw new Error('"when" must be defined in the conditional style object and must be function');
    t.when(e) && (n = t.style || {}, "function" == typeof t.style && (n = t.style(e) || {}));
  }), n;
}

function x(e, t, n) {
  return void 0 === t && (t = []), void 0 === n && (n = "id"), e[n] ? t.some(function (t) {
    return t[n] === e[n];
  }) : t.some(function (t) {
    return t === e;
  });
}

function y(e) {
  if (void 0 === e && (e = exports.Direction.AUTO), "auto" === e) {
    var t = !("undefined" == typeof window || !window.document || !window.document.createElement),
        n = document.getElementsByTagName("BODY")[0],
        o = document.getElementsByTagName("HTML")[0],
        r = "rtl" === n.dir || "rtl" === o.dir;
    return t && r;
  }

  return "rtl" === e;
}

function C(e, t) {
  switch (t.type) {
    case "UPDATE_ROWS":
      var n = t.rows;
      return _l(_l({}, e), {
        rows: n
      });

    case "SELECT_ALL_ROWS":
      var o = t.keyField,
          r = t.rows,
          i = t.rowCount,
          a = t.mergeSelections,
          d = !e.allSelected;

      if (a) {
        var c = d ? s(e.selectedRows, r.filter(function (t) {
          return !x(t, e.selectedRows, o);
        })) : e.selectedRows.filter(function (e) {
          return !x(e, r, o);
        });
        return _l(_l({}, e), {
          allSelected: d,
          selectedCount: c.length,
          selectedRows: c
        });
      }

      return _l(_l({}, e), {
        allSelected: d,
        selectedCount: d ? i : 0,
        selectedRows: d ? r : []
      });

    case "SELECT_SINGLE_ROW":
      var u = t.keyField,
          p = t.row,
          f = t.isSelected;
      i = t.rowCount;
      return _l(_l({}, e), f ? {
        selectedCount: e.selectedRows.length > 0 ? e.selectedRows.length - 1 : 0,
        allSelected: !1,
        selectedRows: h(e.selectedRows, p, u)
      } : {
        selectedCount: e.selectedRows.length + 1,
        allSelected: e.selectedRows.length + 1 === i,
        selectedRows: (_ = e.selectedRows, T = p, void 0 === _ && (_ = []), void 0 === A && (A = 0), s(_.slice(0, A), [T], _.slice(A)))
      });

    case "SELECT_MULTIPLE_ROWS":
      var g = t.keyField,
          w = t.selectedRows;
      n = t.rows;

      if (a = t.mergeSelections) {
        c = s(e.selectedRows, w.filter(function (t) {
          return !x(t, e.selectedRows, g);
        }));
        return _l(_l({}, e), {
          selectedCount: c.length,
          allSelected: !1,
          selectedRows: c
        });
      }

      return _l(_l({}, e), {
        selectedCount: w.length,
        allSelected: w.length === n.length,
        selectedRows: w
      });

    case "SORT_CHANGE":
      n = t.rows;
      var v = t.sortDirection,
          m = t.sortServer,
          b = t.selectedColumn,
          y = t.pagination,
          C = t.paginationServer,
          R = t.visibleOnly,
          S = t.persistSelectedOnSort,
          E = y && C && !S || m || R;
      return _l(_l(_l({}, e), {
        rows: n,
        selectedColumn: b,
        sortDirection: v,
        currentPage: 1
      }), E && {
        allSelected: !1,
        selectedCount: 0,
        selectedRows: []
      });

    case "CHANGE_PAGE":
      var P = t.page,
          k = (C = t.paginationServer, R = t.visibleOnly, t.persistSelectedOnPageChange),
          O = (a = C && k, C && !k || R);
      return _l(_l(_l(_l({}, e), {
        currentPage: P
      }), a && {
        allSelected: !1
      }), O && {
        allSelected: !1,
        selectedCount: 0,
        selectedRows: []
      });

    case "CHANGE_ROWS_PER_PAGE":
      var H = t.rowsPerPage;
      P = t.page;
      return _l(_l({}, e), {
        currentPage: P,
        rowsPerPage: H
      });

    case "CLEAR_SELECTED_ROWS":
      var F = t.selectedRowsFlag;
      return _l(_l({}, e), {
        allSelected: !1,
        selectedCount: 0,
        selectedRows: [],
        selectedRowsFlag: F
      });

    default:
      throw new Error("Unhandled action type: " + t.type);
  }

  var _, T, A;
}

var R,
    S,
    E,
    P,
    k,
    O,
    H,
    F,
    _,
    T,
    A,
    I,
    z,
    M,
    D,
    L,
    j = t.css(R || (R = c(["\n\tpointer-events: none;\n\topacity: 0.4;\n"], ["\n\tpointer-events: none;\n\topacity: 0.4;\n"]))),
    N = i.default.div(S || (S = c(["\n\tposition: relative;\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\theight: 100%;\n\tmax-width: 100%;\n\t", ";\n\t", ";\n"], ["\n\tposition: relative;\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\theight: 100%;\n\tmax-width: 100%;\n\t", ";\n\t", ";\n"])), function (e) {
  return e.disabled && j;
}, function (e) {
  return e.theme.table.style;
}),
    W = i.default.div(E || (E = c(["\n\tdisplay: flex;\n\ttext-align: left;\n\t", ";\n"], ["\n\tdisplay: flex;\n\ttext-align: left;\n\t", ";\n"])), function (e) {
  return e.theme.head.style;
}),
    B = t.css(P || (P = c(["\n\tpointer-events: none;\n"], ["\n\tpointer-events: none;\n"]))),
    G = i.default.div(k || (k = c(["\n\tdisplay: flex;\n\talign-items: stretch;\n\twidth: 100%;\n\t", ";\n\t", ";\n\t", ";\n"], ["\n\tdisplay: flex;\n\talign-items: stretch;\n\twidth: 100%;\n\t", ";\n\t", ";\n\t", ";\n"])), function (e) {
  return e.theme.headRow.style;
}, function (e) {
  var t = e.dense,
      n = e.theme;
  return t && n.headRow.denseStyle;
}, function (e) {
  return e.disabled && B;
}),
    V = function V(e) {
  for (var n = [], o = 1; o < arguments.length; o++) {
    n[o - 1] = arguments[o];
  }

  return t.css(O || (O = c(["\n\t\t@media screen and (max-width: ", "px) {\n\t\t\t", "\n\t\t}\n\t"], ["\n\t\t@media screen and (max-width: ", "px) {\n\t\t\t", "\n\t\t}\n\t"])), 599, t.css.apply(void 0, s([e], n)));
},
    Y = function Y(e) {
  for (var n = [], o = 1; o < arguments.length; o++) {
    n[o - 1] = arguments[o];
  }

  return t.css(H || (H = c(["\n\t\t@media screen and (max-width: ", "px) {\n\t\t\t", "\n\t\t}\n\t"], ["\n\t\t@media screen and (max-width: ", "px) {\n\t\t\t", "\n\t\t}\n\t"])), 959, t.css.apply(void 0, s([e], n)));
},
    U = function U(e) {
  for (var n = [], o = 1; o < arguments.length; o++) {
    n[o - 1] = arguments[o];
  }

  return t.css(F || (F = c(["\n\t\t@media screen and (max-width: ", "px) {\n\t\t\t", "\n\t\t}\n\t"], ["\n\t\t@media screen and (max-width: ", "px) {\n\t\t\t", "\n\t\t}\n\t"])), 1280, t.css.apply(void 0, s([e], n)));
},
    q = function q(e) {
  return function (n) {
    for (var o = [], r = 1; r < arguments.length; r++) {
      o[r - 1] = arguments[r];
    }

    return t.css(_ || (_ = c(["\n\t\t@media screen and (max-width: ", "px) {\n\t\t\t", "\n\t\t}\n\t"], ["\n\t\t@media screen and (max-width: ", "px) {\n\t\t\t", "\n\t\t}\n\t"])), e, t.css.apply(void 0, s([n], o)));
  };
},
    $ = i.default.div(T || (T = c(["\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\tbox-sizing: border-box;\n\tline-height: normal;\n\t", ";\n\t", ";\n"], ["\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\tbox-sizing: border-box;\n\tline-height: normal;\n\t", ";\n\t", ";\n"])), function (e) {
  return e.theme[e.head ? "headCells" : "cells"].style;
}, function (e) {
  return e.noPadding && "padding: 0";
}),
    K = i.default($)(L || (L = c(["\n\tflex-grow: ", ";\n\tflex-shrink: 0;\n\tflex-basis: 0;\n\tmax-width: ", ";\n\tmin-width: ", ";\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n\n\t/* handle hiding cells */\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n"], ["\n\tflex-grow: ", ";\n\tflex-shrink: 0;\n\tflex-basis: 0;\n\tmax-width: ", ";\n\tmin-width: ", ";\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n\n\t/* handle hiding cells */\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n"])), function (e) {
  var t = e.button,
      n = e.grow;
  return 0 === n || t ? 0 : n || 1;
}, function (e) {
  return e.maxWidth || "100%";
}, function (e) {
  return e.minWidth || "100px";
}, function (e) {
  var n = e.width;
  return n && t.css(A || (A = c(["\n\t\t\tmin-width: ", ";\n\t\t\tmax-width: ", ";\n\t\t"], ["\n\t\t\tmin-width: ", ";\n\t\t\tmax-width: ", ";\n\t\t"])), n, n);
}, function (e) {
  return e.right && "justify-content: flex-end";
}, function (e) {
  var t = e.button;
  return (e.center || t) && "justify-content: center";
}, function (e) {
  var t = e.compact,
      n = e.button;
  return (t || n) && "padding: 0";
}, function (e) {
  var t = e.hide;
  return t && "sm" === t && V(I || (I = c(["\n    display: none;\n  "], ["\n    display: none;\n  "])));
}, function (e) {
  var t = e.hide;
  return t && "md" === t && Y(z || (z = c(["\n    display: none;\n  "], ["\n    display: none;\n  "])));
}, function (e) {
  var t = e.hide;
  return t && "lg" === t && U(M || (M = c(["\n    display: none;\n  "], ["\n    display: none;\n  "])));
}, function (e) {
  var t = e.hide;
  return t && Number.isInteger(t) && q(t)(D || (D = c(["\n    display: none;\n  "], ["\n    display: none;\n  "])));
}),
    J = t.css(X || (X = c(["\n\tdiv:first-child {\n\t\twhite-space: ", ";\n\t\toverflow: ", ";\n\t\ttext-overflow: ellipsis;\n\t}\n"], ["\n\tdiv:first-child {\n\t\twhite-space: ", ";\n\t\toverflow: ", ";\n\t\ttext-overflow: ellipsis;\n\t}\n"])), function (e) {
  return e.wrapCell ? "normal" : "nowrap";
}, function (e) {
  return e.allowOverflow ? "visible" : "hidden";
}),
    Q = i.default(K)(Z || (Z = c(["\n\tfont-size: ", ";\n\tfont-weight: 400;\n\t", ";\n\t", ";\n\t", ";\n"], ["\n\tfont-size: ", ";\n\tfont-weight: 400;\n\t", ";\n\t", ";\n\t", ";\n"])), function (e) {
  return e.theme.rows.fontSize;
}, function (e) {
  return !e.renderAsCell && J;
}, function (e) {
  return e.cellStyle;
}, function (e) {
  return e.extendedCellStyle;
});

var X,
    Z,
    ee = e.memo(function (t) {
  var n = t.column,
      o = t.dataTag,
      r = t.extendedCellStyle,
      i = t.id,
      a = t.renderAsCell,
      l = t.children;
  return e.createElement(Q, {
    id: i,
    role: "gridcell",
    className: "rdt_TableCell",
    "data-tag": o,
    cellStyle: n.style,
    extendedCellStyle: r,
    renderAsCell: a,
    allowOverflow: n.allowOverflow,
    button: n.button,
    center: n.center,
    compact: n.compact,
    grow: n.grow,
    hide: n.hide,
    maxWidth: n.maxWidth,
    minWidth: n.minWidth,
    right: n.right,
    width: n.width,
    wrapCell: n.wrap
  }, l);
});
var te,
    ne = e.memo(function (t) {
  var n = t.name,
      o = t.component,
      r = void 0 === o ? "input" : o,
      i = t.componentOptions,
      a = void 0 === i ? {
    style: {}
  } : i,
      d = t.indeterminate,
      s = void 0 !== d && d,
      c = t.checked,
      u = void 0 !== c && c,
      p = t.disabled,
      f = void 0 !== p && p,
      g = t.onClick,
      h = void 0 === g ? m : g,
      w = r,
      v = "input" !== w ? a.style : function (e) {
    return _l(_l({
      fontSize: "18px"
    }, !e && {
      cursor: "pointer"
    }), {
      padding: 0,
      marginTop: "1px",
      verticalAlign: "middle",
      position: "relative"
    });
  }(f),
      b = e.useMemo(function () {
    return function (e) {
      for (var t, n = [], o = 1; o < arguments.length; o++) {
        n[o - 1] = arguments[o];
      }

      return Object.keys(e).map(function (t) {
        return e[t];
      }).forEach(function (o, r) {
        var i;
        "function" == typeof o && (t = _l(_l({}, e), ((i = {})[Object.keys(e)[r]] = o.apply(void 0, n), i)));
      }), t || e;
    }(a, s);
  }, [a, s]);
  return e.createElement(w, _l({
    type: "checkbox",
    ref: function ref(e) {
      e && (e.indeterminate = s);
    },
    style: v,
    onClick: f ? m : h,
    name: n,
    "aria-label": n,
    checked: u,
    disabled: f
  }, b, {
    onChange: m
  }));
}),
    oe = i.default($)(te || (te = c(["\n\tflex: 0 0 48px;\n\tjustify-content: center;\n\talign-items: center;\n\tuser-select: none;\n\twhite-space: nowrap;\n"], ["\n\tflex: 0 0 48px;\n\tjustify-content: center;\n\talign-items: center;\n\tuser-select: none;\n\twhite-space: nowrap;\n"])));

function re(t) {
  var n = t.keyField,
      o = t.row,
      r = t.rowCount,
      i = t.selected,
      a = t.selectableRowsComponent,
      l = t.selectableRowsComponentProps,
      d = t.selectableRowDisabled,
      s = t.onSelectedRow,
      c = !(!d || !d(o));
  return e.createElement(oe, {
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    className: "rdt_TableCell",
    noPadding: !0
  }, e.createElement(ne, {
    name: "select-row-" + o[n],
    component: a,
    componentOptions: l,
    checked: i,
    "aria-checked": i,
    onClick: function onClick() {
      s({
        type: "SELECT_SINGLE_ROW",
        row: o,
        isSelected: i,
        keyField: n,
        rowCount: r
      });
    },
    disabled: c
  }));
}

var ie,
    ae = i.default.button(ie || (ie = c(["\n\tdisplay: inline-flex;\n\talign-items: center;\n\tuser-select: none;\n\twhite-space: nowrap;\n\tborder: none;\n\tbackground-color: transparent;\n\t", ";\n"], ["\n\tdisplay: inline-flex;\n\talign-items: center;\n\tuser-select: none;\n\twhite-space: nowrap;\n\tborder: none;\n\tbackground-color: transparent;\n\t", ";\n"])), function (e) {
  return e.theme.expanderButton.style;
});

function le(t) {
  var n = t.disabled,
      o = void 0 !== n && n,
      r = t.expanded,
      i = void 0 !== r && r,
      a = t.expandableIcon,
      l = t.id,
      d = t.row,
      s = t.onToggled,
      c = i ? a.expanded : a.collapsed;
  return e.createElement(ae, {
    "aria-disabled": o,
    onClick: function onClick() {
      return s && s(d);
    },
    "data-testid": "expander-button-" + l,
    disabled: o,
    "aria-label": i ? "Collapse Row" : "Expand Row",
    role: "button",
    type: "button"
  }, c);
}

var de,
    se = i.default($)(de || (de = c(["\n\twhite-space: nowrap;\n\tfont-weight: 400;\n\t", ";\n"], ["\n\twhite-space: nowrap;\n\tfont-weight: 400;\n\t", ";\n"])), function (e) {
  return e.theme.expanderCell.style;
});

function ce(t) {
  var n = t.row,
      o = t.expanded,
      r = void 0 !== o && o,
      i = t.expandableIcon,
      a = t.id,
      l = t.onToggled,
      d = t.disabled,
      s = void 0 !== d && d;
  return e.createElement(se, {
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    noPadding: !0
  }, e.createElement(le, {
    id: a,
    row: n,
    expanded: r,
    expandableIcon: i,
    disabled: s,
    onToggled: l
  }));
}

var ue,
    pe = i.default.div(ue || (ue = c(["\n\twidth: 100%;\n\tbox-sizing: border-box;\n\t", ";\n\t", ";\n"], ["\n\twidth: 100%;\n\tbox-sizing: border-box;\n\t", ";\n\t", ";\n"])), function (e) {
  return e.theme.expanderRow.style;
}, function (e) {
  return e.extendedRowStyle;
});

function fe(t) {
  var n = t.data,
      o = t.children,
      r = t.extendedRowStyle;
  return e.createElement(pe, {
    className: "rdt_ExpanderRow",
    extendedRowStyle: r
  }, function (t, n) {
    return e.Children.map(t, function (t) {
      return e.cloneElement(t, {
        data: n
      });
    });
  }(o, n));
}

var ge = {
  columns: [],
  data: [],
  title: "",
  keyField: "id",
  selectableRows: !1,
  selectableRowsHighlight: !1,
  selectableRowsNoSelectAll: !1,
  selectableRowSelected: null,
  selectableRowDisabled: null,
  selectableRowsComponent: "input",
  selectableRowsComponentProps: {},
  selectableRowsVisibleOnly: !1,
  clearSelectedRows: !1,
  expandableRows: !1,
  expandableRowDisabled: null,
  expandableRowExpanded: null,
  expandOnRowClicked: !1,
  expandableRowsHideExpander: !1,
  expandOnRowDoubleClicked: !1,
  expandableInheritConditionalStyles: !1,
  progressPending: !1,
  progressComponent: r.default.createElement("div", {
    style: {
      fontSize: "24px",
      fontWeight: 700,
      padding: "24px"
    }
  }, "Loading..."),
  persistTableHead: !1,
  expandableRowsComponent: r.default.createElement("div", {
    style: {
      padding: "24px"
    }
  }, "Add a custom expander component. Use props.data for row data"),
  expandableIcon: {
    collapsed: r.default.createElement(function () {
      return r.default.createElement("svg", {
        fill: "currentColor",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg"
      }, r.default.createElement("path", {
        d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
      }), r.default.createElement("path", {
        d: "M0-.25h24v24H0z",
        fill: "none"
      }));
    }, null),
    expanded: r.default.createElement(function () {
      return r.default.createElement("svg", {
        fill: "currentColor",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg"
      }, r.default.createElement("path", {
        d: "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"
      }), r.default.createElement("path", {
        d: "M0-.75h24v24H0z",
        fill: "none"
      }));
    }, null)
  },
  sortIcon: null,
  sortFunction: null,
  sortServer: !1,
  striped: !1,
  highlightOnHover: !1,
  pointerOnHover: !1,
  noContextMenu: !1,
  contextMessage: {
    singular: "item",
    plural: "items",
    message: "selected"
  },
  actions: [],
  contextActions: [],
  contextComponent: null,
  defaultSortFieldId: null,
  defaultSortAsc: !0,
  responsive: !0,
  overflowY: !1,
  overflowYOffset: "250px",
  noDataComponent: r.default.createElement("div", {
    style: {
      padding: "24px"
    }
  }, "There are no records to display"),
  disabled: !1,
  noTableHead: !1,
  noHeader: !1,
  subHeader: !1,
  subHeaderAlign: exports.Alignment.Right,
  subHeaderWrap: !0,
  subHeaderComponent: [],
  fixedHeader: !1,
  fixedHeaderScrollHeight: "100vh",
  pagination: !1,
  paginationServer: !1,
  paginationServerOptions: {
    persistSelectedOnSort: !1,
    persistSelectedOnPageChange: !1
  },
  paginationDefaultPage: 1,
  paginationResetDefaultPage: !1,
  paginationTotalRows: 0,
  paginationPerPage: 10,
  paginationRowsPerPageOptions: [10, 15, 20, 25, 30],
  paginationComponent: null,
  paginationComponentOptions: {},
  paginationIconFirstPage: r.default.createElement(function () {
    return r.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      "aria-hidden": "true",
      role: "presentation"
    }, r.default.createElement("path", {
      d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
    }), r.default.createElement("path", {
      fill: "none",
      d: "M24 24H0V0h24v24z"
    }));
  }, null),
  paginationIconLastPage: r.default.createElement(function () {
    return r.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      "aria-hidden": "true",
      role: "presentation"
    }, r.default.createElement("path", {
      d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
    }), r.default.createElement("path", {
      fill: "none",
      d: "M0 0h24v24H0V0z"
    }));
  }, null),
  paginationIconNext: r.default.createElement(function () {
    return r.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      "aria-hidden": "true",
      role: "presentation"
    }, r.default.createElement("path", {
      d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
    }), r.default.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    }));
  }, null),
  paginationIconPrevious: r.default.createElement(function () {
    return r.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      "aria-hidden": "true",
      role: "presentation"
    }, r.default.createElement("path", {
      d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
    }), r.default.createElement("path", {
      d: "M0 0h24v24H0z",
      fill: "none"
    }));
  }, null),
  dense: !1,
  conditionalRowStyles: [],
  theme: "default",
  customStyles: {},
  direction: exports.Direction.AUTO,
  onChangePage: m,
  onChangeRowsPerPage: m,
  onRowClicked: m,
  onRowDoubleClicked: m,
  onRowExpandToggled: m,
  onSelectedRowsChange: m,
  onSort: m
},
    he = t.css(me || (me = c(["\n\t&:hover {\n\t\t", ";\n\t}\n"], ["\n\t&:hover {\n\t\t", ";\n\t}\n"])), function (e) {
  var t = e.highlightOnHover,
      n = e.theme;
  return t && n.rows.highlightOnHoverStyle;
}),
    we = t.css(be || (be = c(["\n\t&:hover {\n\t\tcursor: pointer;\n\t}\n"], ["\n\t&:hover {\n\t\tcursor: pointer;\n\t}\n"]))),
    ve = i.default.div(xe || (xe = c(["\n\tdisplay: flex;\n\talign-items: stretch;\n\talign-content: stretch;\n\twidth: 100%;\n\tbox-sizing: border-box;\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n"], ["\n\tdisplay: flex;\n\talign-items: stretch;\n\talign-content: stretch;\n\twidth: 100%;\n\tbox-sizing: border-box;\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n\t", ";\n"])), function (e) {
  return e.theme.rows.style;
}, function (e) {
  var t = e.dense,
      n = e.theme;
  return t && n.rows.denseStyle;
}, function (e) {
  var t = e.striped,
      n = e.theme;
  return t && n.rows.stripedStyle;
}, function (e) {
  return e.highlightOnHover && he;
}, function (e) {
  return e.pointerOnHover && we;
}, function (e) {
  var t = e.selected,
      n = e.theme;
  return t && n.rows.selectedHighlightStyle;
}, function (e) {
  return e.extendedRowStyle;
});

var me,
    be,
    xe,
    ye,
    Ce = e.memo(function (t) {
  var n = t.columns,
      o = void 0 === n ? [] : n,
      r = t.conditionalRowStyles,
      i = void 0 === r ? [] : r,
      a = t.defaultExpanded,
      l = void 0 !== a && a,
      d = t.defaultExpanderDisabled,
      s = void 0 !== d && d,
      c = t.dense,
      u = void 0 !== c && c,
      p = t.expandableIcon,
      f = void 0 === p ? ge.expandableIcon : p,
      g = t.expandableRows,
      h = void 0 !== g && g,
      w = t.expandableRowsComponent,
      v = void 0 === w ? ge.expandableRowsComponent : w,
      x = t.expandableRowsHideExpander,
      y = t.expandOnRowClicked,
      C = t.expandOnRowDoubleClicked,
      R = t.highlightOnHover,
      S = void 0 !== R && R,
      E = t.id,
      P = t.expandableInheritConditionalStyles,
      k = t.keyField,
      O = void 0 === k ? ge.keyField : k,
      H = t.onRowClicked,
      F = void 0 === H ? m : H,
      _ = t.onRowDoubleClicked,
      T = void 0 === _ ? m : _,
      A = t.onRowExpandToggled,
      I = void 0 === A ? m : A,
      z = t.onSelectedRow,
      M = void 0 === z ? m : z,
      D = t.pointerOnHover,
      L = void 0 !== D && D,
      j = t.row,
      N = t.rowCount,
      W = t.rowIndex,
      B = t.selectableRowDisabled,
      G = void 0 === B ? null : B,
      V = t.selectableRows,
      Y = void 0 !== V && V,
      U = t.selectableRowsComponent,
      q = void 0 === U ? ge.selectableRowsComponent : U,
      $ = t.selectableRowsComponentProps,
      K = void 0 === $ ? ge.selectableRowsComponentProps : $,
      J = t.selectableRowsHighlight,
      Q = void 0 !== J && J,
      X = t.selected,
      Z = t.striped,
      te = void 0 === Z ? ge.striped : Z,
      ne = e.useState(l),
      oe = ne[0],
      ie = ne[1];
  e.useEffect(function () {
    ie(l);
  }, [l]);
  var ae = e.useCallback(function () {
    ie(!oe), I(!oe, j);
  }, [oe, I, j]),
      le = L || h && (y || C),
      de = e.useCallback(function (e) {
    e.target && "allowRowEvents" === e.target.getAttribute("data-tag") && (F(j, e), !s && h && y && ae());
  }, [s, y, h, ae, F, j]),
      se = e.useCallback(function (e) {
    e.target && "allowRowEvents" === e.target.getAttribute("data-tag") && (T(j, e), !s && h && C && ae());
  }, [s, C, h, ae, T, j]),
      ue = b(j, i),
      pe = Q && X,
      he = P ? ue : {},
      we = te && W % 2 == 0;
  return e.createElement(e.Fragment, null, e.createElement(ve, {
    id: "row-" + E,
    role: "row",
    striped: we,
    highlightOnHover: S,
    pointerOnHover: !s && le,
    dense: u,
    onClick: de,
    onDoubleClick: se,
    className: "rdt_TableRow",
    extendedRowStyle: ue,
    selected: pe
  }, Y && e.createElement(re, {
    keyField: O,
    row: j,
    rowCount: N,
    selected: X,
    selectableRowsComponent: q,
    selectableRowsComponentProps: K,
    selectableRowDisabled: G,
    onSelectedRow: M
  }), h && !x && e.createElement(ce, {
    id: j[O],
    expandableIcon: f,
    expanded: oe,
    row: j,
    onToggled: ae,
    disabled: s
  }), o.map(function (t) {
    if (t.omit) return null;
    var n = t.ignoreRowClick || t.button ? null : "allowRowEvents",
        o = b(j, t.conditionalCellStyles);
    return e.createElement(ee, {
      id: "cell-" + t.id + "-" + j[O],
      key: "cell-" + t.id + "-" + j[O],
      extendedCellStyle: o,
      dataTag: n,
      renderAsCell: !!t.cell,
      column: t
    }, !t.cell && e.createElement("div", {
      "data-tag": n
    }, function (e, t, n, o) {
      if (!t) return null;
      if ("string" != typeof t && "function" != typeof t) throw new Error("selector must be a . delimited string eg (my.property) or function (e.g. row => row.field");
      return n && "function" == typeof n ? n(e, o) : t && "function" == typeof t ? t(e, o) : t.split(".").reduce(function (e, t) {
        var n = t.match(/[^\]\\[.]+/g);
        if (n && n.length > 1) for (var o = 0; o < n.length; o++) {
          return e[n[o]][n[o + 1]];
        }
        return e[t];
      }, e);
    }(j, t.selector, t.format, W)), t.cell && t.cell(j, W, t, E));
  })), h && oe && e.createElement(fe, {
    key: "expander--" + j[O],
    data: j,
    extendedRowStyle: he
  }, v));
}),
    Re = i.default.span(ye || (ye = c(["\n\tpadding: 2px;\n\tcolor: inherit;\n\tflex-grow: 0;\n\tflex-shrink: 0;\n\t", ";\n\t", ";\n"], ["\n\tpadding: 2px;\n\tcolor: inherit;\n\tflex-grow: 0;\n\tflex-shrink: 0;\n\t", ";\n\t", ";\n"])), function (e) {
  return e.sortActive ? "opacity: 1" : "opacity: 0";
}, function (e) {
  return "desc" === e.sortDirection && "transform: rotate(180deg)";
}),
    Se = function Se(e) {
  var t = e.sortActive,
      n = e.sortDirection;
  return r.default.createElement(Re, {
    sortActive: t,
    sortDirection: n
  }, "▲");
},
    Ee = i.default(K)(ke || (ke = c(["\n\t", ";\n"], ["\n\t", ";\n"])), function (e) {
  return e.button && "text-align: center";
}),
    Pe = i.default.div(Oe || (Oe = c(["\n\tdisplay: inline-flex;\n\talign-items: center;\n\theight: 100%;\n\tline-height: 1;\n\tuser-select: none;\n\t", ";\n\n\tspan.__rdt_custom_sort_icon__ {\n\t\ti,\n\t\tsvg {\n\t\t\t", ";\n\t\t\tcolor: inherit;\n\t\t\tfont-size: 18px !important;\n\t\t\theight: 18px !important;\n\t\t\twidth: 18px !important;\n\t\t\tbackface-visibility: hidden;\n\t\t\ttransform-style: preserve-3d;\n\t\t\ttransition-duration: 125ms;\n\t\t\ttransition-property: transform;\n\t\t}\n\n\t\t&.asc i,\n\t\t&.asc svg {\n\t\t\ttransform: rotate(180deg);\n\t\t}\n\t}\n\n\t&:hover {\n\t\t", ";\n\t\t", ";\n\n\t\tspan,\n\t\tspan.__rdt_custom_sort_icon__ * {\n\t\t\t", ";\n\t\t}\n\t}\n"], ["\n\tdisplay: inline-flex;\n\talign-items: center;\n\theight: 100%;\n\tline-height: 1;\n\tuser-select: none;\n\t", ";\n\n\tspan.__rdt_custom_sort_icon__ {\n\t\ti,\n\t\tsvg {\n\t\t\t", ";\n\t\t\tcolor: inherit;\n\t\t\tfont-size: 18px !important;\n\t\t\theight: 18px !important;\n\t\t\twidth: 18px !important;\n\t\t\tbackface-visibility: hidden;\n\t\t\ttransform-style: preserve-3d;\n\t\t\ttransition-duration: 125ms;\n\t\t\ttransition-property: transform;\n\t\t}\n\n\t\t&.asc i,\n\t\t&.asc svg {\n\t\t\ttransform: rotate(180deg);\n\t\t}\n\t}\n\n\t&:hover {\n\t\t", ";\n\t\t", ";\n\n\t\tspan,\n\t\tspan.__rdt_custom_sort_icon__ * {\n\t\t\t", ";\n\t\t}\n\t}\n"])), function (e) {
  var t = e.theme;
  return e.sortActive ? t.headCells.activeSortStyle : t.headCells.inactiveSortStyle;
}, function (e) {
  return e.sortActive ? "opacity: 1" : "opacity: 0";
}, function (e) {
  return e.sortable && "cursor: pointer";
}, function (e) {
  var t = e.sortable,
      n = e.theme;
  return t && n.headCells.activeStyle;
}, function (e) {
  var t = e.sortActive,
      n = e.sortable;
  return !t && n && "opacity: 1";
});

var ke,
    Oe,
    He,
    Fe = e.memo(function (t) {
  var n = t.rows,
      o = t.column,
      r = t.selectedColumn,
      i = t.sortDirection,
      a = t.sortFunction,
      l = t.sortIcon,
      d = t.sortServer,
      c = t.pagination,
      u = t.paginationServer,
      p = t.persistSelectedOnSort,
      f = t.selectableRowsVisibleOnly,
      h = t.onSort;
  if (o.omit) return null;

  var w = function w() {
    if (o.sortable && o.selector) {
      var e = i;
      r.id === o.id && (e = "asc" === i ? "desc" : "asc");
      var t = g(n, o.selector, e, a),
          l = o.sortFunction;

      if (l) {
        var w = "asc" === e ? l : function (e, t) {
          return -1 * l(e, t);
        };
        t = s(n).sort(w);
      }

      h({
        type: "SORT_CHANGE",
        rows: t,
        sortDirection: e,
        sortServer: d,
        selectedColumn: o,
        pagination: c,
        paginationServer: u,
        visibleOnly: f,
        persistSelectedOnSort: p
      });
    }
  },
      v = function v(t) {
    return e.createElement(Se, {
      sortActive: t,
      sortDirection: i
    });
  },
      m = function m() {
    return e.createElement("span", {
      className: [i, "__rdt_custom_sort_icon__"].join(" ")
    }, l);
  },
      b = !(!o.sortable || r.id !== o.id),
      x = o.sortable && !l && !o.right,
      y = o.sortable && !l && o.right,
      C = o.sortable && l && !o.right,
      R = o.sortable && l && o.right;

  return e.createElement(Ee, {
    className: "rdt_TableCol",
    head: !0,
    allowOverflow: o.allowOverflow,
    button: o.button,
    compact: o.compact,
    grow: o.grow,
    hide: o.hide,
    maxWidth: o.maxWidth,
    minWidth: o.minWidth,
    right: o.right,
    width: o.width
  }, o.name && e.createElement(Pe, {
    id: "column-" + o.id,
    role: "columnheader",
    tabIndex: 0,
    className: "rdt_TableCol_Sortable",
    onClick: w,
    onKeyPress: function onKeyPress(e) {
      "Enter" === e.key && w();
    },
    sortable: o.sortable,
    sortActive: b
  }, R && m(), y && v(b), e.createElement("div", null, o.name), C && m(), x && v(b)));
}),
    _e = i.default($)(He || (He = c(["\n\tflex: 0 0 48px;\n\tjustify-content: center;\n\talign-items: center;\n\tuser-select: none;\n\twhite-space: nowrap;\n"], ["\n\tflex: 0 0 48px;\n\tjustify-content: center;\n\talign-items: center;\n\tuser-select: none;\n\twhite-space: nowrap;\n"])));

function Te(t) {
  var n = t.head,
      o = void 0 === n || n,
      r = t.rowData,
      i = t.keyField,
      a = t.allSelected,
      l = t.mergeSelections,
      d = t.selectedRows,
      s = t.selectableRowsComponent,
      c = t.selectableRowsComponentProps,
      u = t.selectableRowDisabled,
      p = t.onSelectAllRows,
      f = d.length > 0 && !a,
      g = u ? r.filter(function (e) {
    return !u(e);
  }) : r,
      h = 0 === g.length,
      w = Math.min(r.length, g.length);
  return e.createElement(_e, {
    className: "rdt_TableCol",
    head: o,
    noPadding: !0
  }, e.createElement(ne, {
    name: "select-all-rows",
    component: s,
    componentOptions: c,
    onClick: function onClick() {
      p({
        type: "SELECT_ALL_ROWS",
        rows: g,
        rowCount: w,
        mergeSelections: l,
        keyField: i
      });
    },
    checked: a,
    indeterminate: f,
    disabled: h
  }));
}

var Ae,
    Ie,
    ze,
    Me = i.default.div(Ae || (Ae = c(["\n\tdisplay: flex;\n\talign-items: center;\n\tflex: 1 0 auto;\n\theight: 100%;\n\tcolor: ", ";\n\tfont-size: ", ";\n\tfont-weight: 400;\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tflex: 1 0 auto;\n\theight: 100%;\n\tcolor: ", ";\n\tfont-size: ", ";\n\tfont-weight: 400;\n"])), function (e) {
  return e.theme.contextMenu.fontColor;
}, function (e) {
  return e.theme.contextMenu.fontSize;
}),
    De = i.default.div(Ie || (Ie = c(["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n\tflex-wrap: wrap;\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n\tflex-wrap: wrap;\n"]))),
    Le = i.default.div(ze || (ze = c(["\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tbox-sizing: inherit;\n\tz-index: 1;\n\talign-items: center;\n\tjustify-content: space-between;\n\tdisplay: flex;\n\t", ";\n\t", ";\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tbox-sizing: inherit;\n\tz-index: 1;\n\talign-items: center;\n\tjustify-content: space-between;\n\tdisplay: flex;\n\t", ";\n\t", ";\n"])), function (e) {
  return e.theme.contextMenu.style;
}, function (e) {
  var t = e.theme;
  return e.visible && t.contextMenu.activeStyle;
});

function je(t) {
  var n = t.contextMessage,
      o = t.contextActions,
      r = t.contextComponent,
      i = t.selectedCount,
      a = t.direction,
      l = i > 0;
  return r ? e.createElement(Le, {
    visible: l
  }, e.cloneElement(r, {
    selectedCount: i
  })) : e.createElement(Le, {
    visible: l
  }, e.createElement(Me, null, function (e, t, n) {
    if (0 === t) return null;
    var o = 1 === t ? e.singular : e.plural;
    return y(n) ? t + " " + (e.message || "") + " " + o : t + " " + o + " " + (e.message || "");
  }(n, i, a)), e.createElement(De, null, o));
}

var Ne,
    We,
    Be,
    Ge,
    Ve,
    Ye,
    Ue,
    qe,
    $e,
    Ke,
    Je,
    Qe,
    Xe,
    Ze,
    et,
    tt,
    nt,
    ot,
    rt,
    it,
    at,
    lt,
    dt = i.default.div(Ne || (Ne = c(["\n\tposition: relative;\n\tbox-sizing: border-box;\n\toverflow: hidden;\n\tdisplay: flex;\n\tflex: 1 1 auto;\n\talign-items: center;\n\tjustify-content: space-between;\n\twidth: 100%;\n\tflex-wrap: wrap;\n\t", "\n"], ["\n\tposition: relative;\n\tbox-sizing: border-box;\n\toverflow: hidden;\n\tdisplay: flex;\n\tflex: 1 1 auto;\n\talign-items: center;\n\tjustify-content: space-between;\n\twidth: 100%;\n\tflex-wrap: wrap;\n\t", "\n"])), function (e) {
  return e.theme.header.style;
}),
    st = i.default.div(We || (We = c(["\n\tflex: 1 0 auto;\n\tcolor: ", ";\n\tfont-size: ", ";\n\tfont-weight: 400;\n"], ["\n\tflex: 1 0 auto;\n\tcolor: ", ";\n\tfont-size: ", ";\n\tfont-weight: 400;\n"])), function (e) {
  return e.theme.header.fontColor;
}, function (e) {
  return e.theme.header.fontSize;
}),
    ct = i.default.div(Be || (Be = c(["\n\tflex: 1 0 auto;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n\n\t> * {\n\t\tmargin-left: 5px;\n\t}\n"], ["\n\tflex: 1 0 auto;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n\n\t> * {\n\t\tmargin-left: 5px;\n\t}\n"]))),
    ut = function ut(t) {
  var n = t.title,
      o = t.actions,
      r = void 0 === o ? [] : o,
      i = t.contextMessage,
      a = t.contextActions,
      l = t.contextComponent,
      d = t.selectedCount,
      s = t.direction,
      c = t.showMenu,
      u = void 0 === c || c;
  return e.createElement(dt, {
    className: "rdt_TableHeader",
    role: "heading",
    "aria-level": 1
  }, e.createElement(st, null, n), e.createElement(ct, null, r), u && e.createElement(je, {
    contextMessage: i,
    contextActions: a,
    contextComponent: l,
    direction: s,
    selectedCount: d
  }));
},
    pt = {
  left: "flex-start",
  right: "flex-end",
  center: "center"
},
    ft = i.default.header(Ge || (Ge = c(["\n\tposition: relative;\n\tdisplay: flex;\n\tflex: 1 1 auto;\n\tbox-sizing: border-box;\n\talign-items: center;\n\tpadding: 4px 16px 4px 24px;\n\twidth: 100%;\n\tjustify-content: ", ";\n\tflex-wrap: ", ";\n\t", "\n"], ["\n\tposition: relative;\n\tdisplay: flex;\n\tflex: 1 1 auto;\n\tbox-sizing: border-box;\n\talign-items: center;\n\tpadding: 4px 16px 4px 24px;\n\twidth: 100%;\n\tjustify-content: ", ";\n\tflex-wrap: ", ";\n\t", "\n"])), function (e) {
  var t = e.align;
  return pt[t];
}, function (e) {
  return e.wrapContent ? "wrap" : "nowrap";
}, function (e) {
  return e.theme.subHeader.style;
}),
    gt = function gt(t) {
  var n = t.align,
      o = void 0 === n ? "right" : n,
      r = t.wrapContent,
      i = void 0 === r || r,
      a = d(t, ["align", "wrapContent"]);
  return e.createElement(ft, _l({
    align: o,
    wrapContent: i
  }, a));
},
    ht = i.default.div(Ye || (Ye = c(["\n\tdisplay: flex;\n\tflex-direction: column;\n\t", ";\n"], ["\n\tdisplay: flex;\n\tflex-direction: column;\n\t", ";\n"])), function (e) {
  var n = e.fixedHeader,
      o = void 0 !== n && n,
      r = e.hasOffset,
      i = void 0 !== r && r,
      a = e.offset,
      l = void 0 === a ? 0 : a,
      d = e.fixedHeaderScrollHeight,
      s = void 0 === d ? "100vh" : d;
  return o && t.css(Ve || (Ve = c(["\n\t\t\tmax-height: ", ";\n\t\t\toverflow-y: scroll;\n\t\t\t-webkit-overflow-scrolling: touch;\n\t\t"], ["\n\t\t\tmax-height: ", ";\n\t\t\toverflow-y: scroll;\n\t\t\t-webkit-overflow-scrolling: touch;\n\t\t"])), i ? "calc(" + s + " - " + l + ")" : s);
}),
    wt = i.default.div($e || ($e = c(["\n\tposition: relative;\n\twidth: 100%;\n\tborder-radius: inherit;\n\t", ";\n\t", ";\n"], ["\n\tposition: relative;\n\twidth: 100%;\n\tborder-radius: inherit;\n\t", ";\n\t", ";\n"])), function (e) {
  return e.responsive && t.css(Ue || (Ue = c(["\n\t\t\toverflow-x: auto;\n\n\t\t\t// prevents vertical scrolling in firefox\n\t\t\toverflow-y: hidden;\n\t\t\tmin-height: 0;\n\t\t"], ["\n\t\t\toverflow-x: auto;\n\n\t\t\t// prevents vertical scrolling in firefox\n\t\t\toverflow-y: hidden;\n\t\t\tmin-height: 0;\n\t\t"])));
}, function (e) {
  var n = e.overflowY,
      o = e.overflowYOffset,
      r = e.responsive;
  return n && r && o && t.css(qe || (qe = c(["\n\t\t\tpadding-bottom: ", ";\n\t\t\tmargin-bottom: -", ";\n\t\t"], ["\n\t\t\tpadding-bottom: ", ";\n\t\t\tmargin-bottom: -", ";\n\t\t"])), o, o);
}),
    vt = i.default.div(Ke || (Ke = c(["\n\tposition: relative;\n\tbox-sizing: border-box;\n\twidth: 100%;\n\theight: 100%;\n\t", ";\n"], ["\n\tposition: relative;\n\tbox-sizing: border-box;\n\twidth: 100%;\n\theight: 100%;\n\t", ";\n"])), function (e) {
  return e.theme.progress.style;
}),
    mt = i.default.div(Je || (Je = c(["\n\tposition: relative;\n\twidth: 100%;\n\t", ";\n"], ["\n\tposition: relative;\n\twidth: 100%;\n\t", ";\n"])), function (e) {
  return e.theme.tableWrapper.style;
}),
    bt = i.default($)(Qe || (Qe = c(["\n\twhite-space: nowrap;\n\t", ";\n"], ["\n\twhite-space: nowrap;\n\t", ";\n"])), function (e) {
  return e.theme.expanderCell.style;
}),
    xt = i.default.div(Xe || (Xe = c(["\n\tbox-sizing: border-box;\n\twidth: 100%;\n\theight: 100%;\n\t", ";\n"], ["\n\tbox-sizing: border-box;\n\twidth: 100%;\n\theight: 100%;\n\t", ";\n"])), function (e) {
  return e.theme.noData.style;
}),
    yt = function yt() {
  return r.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, r.default.createElement("path", {
    d: "M7 10l5 5 5-5z"
  }), r.default.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
},
    Ct = i.default.select(Ze || (Ze = c(["\n\tcursor: pointer;\n\theight: 24px;\n\tmin-width: 24px;\n\tuser-select: none;\n\tpadding-left: 8px;\n\tpadding-right: 12px;\n\tbox-sizing: content-box;\n\tfont-size: inherit;\n\tcolor: inherit;\n\tborder: none;\n\tbackground-color: transparent;\n\tappearance: none;\n\tdirection: ltr;\n\n\t&::-ms-expand {\n\t\tdisplay: none;\n\t}\n\n\t&:disabled::-ms-expand {\n\t\tbackground: #f60;\n\t}\n\n\toption {\n\t\tcolor: initial;\n\t}\n"], ["\n\tcursor: pointer;\n\theight: 24px;\n\tmin-width: 24px;\n\tuser-select: none;\n\tpadding-left: 8px;\n\tpadding-right: 12px;\n\tbox-sizing: content-box;\n\tfont-size: inherit;\n\tcolor: inherit;\n\tborder: none;\n\tbackground-color: transparent;\n\tappearance: none;\n\tdirection: ltr;\n\n\t&::-ms-expand {\n\t\tdisplay: none;\n\t}\n\n\t&:disabled::-ms-expand {\n\t\tbackground: #f60;\n\t}\n\n\toption {\n\t\tcolor: initial;\n\t}\n"]))),
    Rt = i.default.div(et || (et = c(["\n\tposition: relative;\n\tflex-shrink: 0;\n\tfont-size: inherit;\n\tcolor: inherit;\n\tmargin-top: 1px;\n\n\tsvg {\n\t\ttop: 0;\n\t\tright: 0;\n\t\tcolor: inherit;\n\t\tposition: absolute;\n\t\tfill: currentColor;\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tdisplay: inline-block;\n\t\tuser-select: none;\n\t\tpointer-events: none;\n\t}\n"], ["\n\tposition: relative;\n\tflex-shrink: 0;\n\tfont-size: inherit;\n\tcolor: inherit;\n\tmargin-top: 1px;\n\n\tsvg {\n\t\ttop: 0;\n\t\tright: 0;\n\t\tcolor: inherit;\n\t\tposition: absolute;\n\t\tfill: currentColor;\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tdisplay: inline-block;\n\t\tuser-select: none;\n\t\tpointer-events: none;\n\t}\n"]))),
    St = function St(t) {
  var n = t.defaultValue,
      o = t.onChange,
      r = d(t, ["defaultValue", "onChange"]);
  return e.createElement(Rt, null, e.createElement(Ct, _l({
    onChange: o,
    defaultValue: n
  }, r)), e.createElement(yt, null));
},
    Et = {
  rowsPerPageText: "Rows per page:",
  rangeSeparatorText: "of",
  noRowsPerPage: !1,
  selectAllRowsItem: !1,
  selectAllRowsItemText: "All"
},
    Pt = i.default.nav(tt || (tt = c(["\n\tdisplay: flex;\n\tflex: 1 1 auto;\n\tjustify-content: flex-end;\n\talign-items: center;\n\tbox-sizing: border-box;\n\tpadding-right: 8px;\n\tpadding-left: 8px;\n\twidth: 100%;\n\t", ";\n"], ["\n\tdisplay: flex;\n\tflex: 1 1 auto;\n\tjustify-content: flex-end;\n\talign-items: center;\n\tbox-sizing: border-box;\n\tpadding-right: 8px;\n\tpadding-left: 8px;\n\twidth: 100%;\n\t", ";\n"])), function (e) {
  return e.theme.pagination.style;
}),
    kt = i.default.button(nt || (nt = c(["\n\tposition: relative;\n\tdisplay: block;\n\tuser-select: none;\n\tborder: none;\n\t", ";\n\t", ";\n"], ["\n\tposition: relative;\n\tdisplay: block;\n\tuser-select: none;\n\tborder: none;\n\t", ";\n\t", ";\n"])), function (e) {
  return e.theme.pagination.pageButtonsStyle;
}, function (e) {
  return e.isRTL && "transform: scale(-1, -1)";
}),
    Ot = i.default.div(rt || (rt = c(["\n\tdisplay: flex;\n\talign-items: center;\n\tborder-radius: 4px;\n\twhite-space: nowrap;\n\t", ";\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n\tborder-radius: 4px;\n\twhite-space: nowrap;\n\t", ";\n"])), V(ot || (ot = c(["\n    width: 100%;\n    justify-content: space-around;\n  "], ["\n    width: 100%;\n    justify-content: space-around;\n  "])))),
    Ht = i.default.span(it || (it = c(["\n\tflex-shrink: 1;\n\tuser-select: none;\n"], ["\n\tflex-shrink: 1;\n\tuser-select: none;\n"]))),
    Ft = i.default(Ht)(at || (at = c(["\n\tmargin: 0 24px;\n"], ["\n\tmargin: 0 24px;\n"]))),
    _t = i.default(Ht)(lt || (lt = c(["\n\tmargin: 0 4px;\n"], ["\n\tmargin: 0 4px;\n"])));

function Tt(t) {
  var n = t.rowsPerPage,
      o = t.rowCount,
      r = t.currentPage,
      i = t.direction,
      a = void 0 === i ? ge.direction : i,
      d = t.paginationRowsPerPageOptions,
      s = void 0 === d ? ge.paginationRowsPerPageOptions : d,
      c = t.paginationIconLastPage,
      u = void 0 === c ? ge.paginationIconLastPage : c,
      p = t.paginationIconFirstPage,
      f = void 0 === p ? ge.paginationIconFirstPage : p,
      g = t.paginationIconNext,
      h = void 0 === g ? ge.paginationIconNext : g,
      v = t.paginationIconPrevious,
      m = void 0 === v ? ge.paginationIconPrevious : v,
      b = t.paginationComponentOptions,
      x = void 0 === b ? ge.paginationComponentOptions : b,
      C = t.onChangeRowsPerPage,
      R = void 0 === C ? ge.onChangeRowsPerPage : C,
      S = t.onChangePage,
      E = void 0 === S ? ge.onChangePage : S,
      P = function () {
    var t = "object" == typeof window;

    function n() {
      return {
        width: t ? window.innerWidth : void 0,
        height: t ? window.innerHeight : void 0
      };
    }

    var o = e.useState(n),
        r = o[0],
        i = o[1];
    return e.useEffect(function () {
      if (!t) return function () {
        return null;
      };

      function e() {
        i(n());
      }

      return window.addEventListener("resize", e), function () {
        return window.removeEventListener("resize", e);
      };
    }, []), r;
  }(),
      k = P.width && P.width > 599,
      O = y(a),
      H = w(o, n),
      F = r * n,
      _ = F - n + 1,
      T = 1 === r,
      A = r === H,
      I = _l(_l({}, Et), x),
      z = r === H ? _ + "-" + o + " " + I.rangeSeparatorText + " " + o : _ + "-" + F + " " + I.rangeSeparatorText + " " + o,
      M = e.useCallback(function () {
    return E(r - 1);
  }, [r, E]),
      D = e.useCallback(function () {
    return E(r + 1);
  }, [r, E]),
      L = e.useCallback(function () {
    return E(1);
  }, [E]),
      j = e.useCallback(function () {
    return E(w(o, n));
  }, [E, o, n]),
      N = e.useCallback(function (e) {
    return R(Number(e.target.value), r);
  }, [r, R]),
      W = s.map(function (t) {
    return e.createElement("option", {
      key: t,
      value: t
    }, t);
  });

  I.selectAllRowsItem && W.push(e.createElement("option", {
    key: -1,
    value: o
  }, I.selectAllRowsItemText));
  var B = e.createElement(St, {
    onChange: N,
    defaultValue: n,
    "aria-label": I.rowsPerPageText
  }, W);
  return e.createElement(Pt, {
    className: "rdt_Pagination"
  }, !I.noRowsPerPage && k && e.createElement(e.Fragment, null, e.createElement(_t, null, I.rowsPerPageText), B), k && e.createElement(Ft, null, z), e.createElement(Ot, null, e.createElement(kt, {
    id: "pagination-first-page",
    type: "button",
    "aria-label": "First Page",
    "aria-disabled": T,
    onClick: L,
    disabled: T,
    isRTL: O
  }, f), e.createElement(kt, {
    id: "pagination-previous-page",
    type: "button",
    "aria-label": "Previous Page",
    "aria-disabled": T,
    onClick: M,
    disabled: T,
    isRTL: O
  }, m), !k && B, e.createElement(kt, {
    id: "pagination-next-page",
    type: "button",
    "aria-label": "Next Page",
    "aria-disabled": A,
    onClick: D,
    disabled: A,
    isRTL: O
  }, h), e.createElement(kt, {
    id: "pagination-last-page",
    type: "button",
    "aria-label": "Last Page",
    "aria-disabled": A,
    onClick: j,
    disabled: A,
    isRTL: O
  }, u)));
}

var At = function At(t, n) {
  var o = e.useRef(!0);
  e.useEffect(function () {
    o.current ? o.current = !1 : t();
  }, n);
},
    It = function It(e) {
  return function (e) {
    return !!e && "object" == typeof e;
  }(e) && !function (e) {
    var t = Object.prototype.toString.call(e);
    return "[object RegExp]" === t || "[object Date]" === t || function (e) {
      return e.$$typeof === zt;
    }(e);
  }(e);
};

var zt = "function" == typeof Symbol && Symbol.for ? Symbol.for("react.element") : 60103;

function Mt(e, t) {
  return !1 !== t.clone && t.isMergeableObject(e) ? Wt((n = e, Array.isArray(n) ? [] : {}), e, t) : e;
  var n;
}

function Dt(e, t, n) {
  return e.concat(t).map(function (e) {
    return Mt(e, n);
  });
}

function Lt(e) {
  return Object.keys(e).concat(function (e) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function (t) {
      return e.propertyIsEnumerable(t);
    }) : [];
  }(e));
}

function jt(e, t) {
  try {
    return t in e;
  } catch (e) {
    return !1;
  }
}

function Nt(e, t, n) {
  var o = {};
  return n.isMergeableObject(e) && Lt(e).forEach(function (t) {
    o[t] = Mt(e[t], n);
  }), Lt(t).forEach(function (r) {
    (function (e, t) {
      return jt(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
    })(e, r) || (jt(e, r) && n.isMergeableObject(t[r]) ? o[r] = function (e, t) {
      if (!t.customMerge) return Wt;
      var n = t.customMerge(e);
      return "function" == typeof n ? n : Wt;
    }(r, n)(e[r], t[r], n) : o[r] = Mt(t[r], n));
  }), o;
}

function Wt(e, t, n) {
  (n = n || {}).arrayMerge = n.arrayMerge || Dt, n.isMergeableObject = n.isMergeableObject || It, n.cloneUnlessOtherwiseSpecified = Mt;
  var o = Array.isArray(t);
  return o === Array.isArray(e) ? o ? n.arrayMerge(e, t, n) : Nt(e, t, n) : Mt(t, n);
}

Wt.all = function (e, t) {
  if (!Array.isArray(e)) throw new Error("first argument should be an array");
  return e.reduce(function (e, n) {
    return Wt(e, n, t);
  }, {});
};

var Bt = Wt,
    Gt = {
  default: {
    text: {
      primary: "rgba(0, 0, 0, 0.87)",
      secondary: "rgba(0, 0, 0, 0.54)",
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    background: {
      default: "#FFFFFF"
    },
    context: {
      background: "#e3f2fd",
      text: "rgba(0, 0, 0, 0.87)"
    },
    divider: {
      default: "rgba(0,0,0,.12)"
    },
    button: {
      default: "rgba(0,0,0,.54)",
      focus: "rgba(0,0,0,.12)",
      hover: "rgba(0,0,0,.12)",
      disabled: "rgba(0, 0, 0, .18)"
    },
    sortFocus: {
      default: "rgba(0, 0, 0, .54)"
    },
    selected: {
      default: "#e3f2fd",
      text: "rgba(0, 0, 0, 0.87)"
    },
    highlightOnHover: {
      default: "#EEEEEE",
      text: "rgba(0, 0, 0, 0.87)"
    },
    striped: {
      default: "#FAFAFA",
      text: "rgba(0, 0, 0, 0.87)"
    }
  },
  dark: {
    text: {
      primary: "#FFFFFF",
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(0,0,0,.12)"
    },
    background: {
      default: "#424242"
    },
    context: {
      background: "#E91E63",
      text: "#FFFFFF"
    },
    divider: {
      default: "rgba(81, 81, 81, 1)"
    },
    button: {
      default: "#FFFFFF",
      focus: "rgba(255, 255, 255, .54)",
      hover: "rgba(255, 255, 255, .12)",
      disabled: "rgba(255, 255, 255, .18)"
    },
    sortFocus: {
      default: "rgba(255, 255, 255, .54)"
    },
    selected: {
      default: "rgba(0, 0, 0, .7)",
      text: "#FFFFFF"
    },
    highlightOnHover: {
      default: "rgba(0, 0, 0, .7)",
      text: "#FFFFFF"
    },
    striped: {
      default: "rgba(0, 0, 0, .87)",
      text: "#FFFFFF"
    }
  }
};
var Vt = e.memo(function (n) {
  var o,
      r = n.data,
      i = void 0 === r ? ge.data : r,
      a = n.columns,
      d = void 0 === a ? ge.columns : a,
      s = n.title,
      c = void 0 === s ? ge.title : s,
      u = n.actions,
      p = void 0 === u ? ge.actions : u,
      f = n.keyField,
      h = void 0 === f ? ge.keyField : f,
      m = n.striped,
      b = void 0 === m ? ge.striped : m,
      y = n.highlightOnHover,
      R = void 0 === y ? ge.highlightOnHover : y,
      S = n.pointerOnHover,
      E = void 0 === S ? ge.pointerOnHover : S,
      P = n.dense,
      k = void 0 === P ? ge.dense : P,
      O = n.selectableRows,
      H = void 0 === O ? ge.selectableRows : O,
      F = n.selectableRowsHighlight,
      _ = void 0 === F ? ge.selectableRowsHighlight : F,
      T = n.selectableRowsNoSelectAll,
      A = void 0 === T ? ge.selectableRowsNoSelectAll : T,
      I = n.selectableRowsVisibleOnly,
      z = void 0 === I ? ge.selectableRowsVisibleOnly : I,
      M = n.selectableRowSelected,
      D = void 0 === M ? ge.selectableRowSelected : M,
      L = n.selectableRowDisabled,
      j = void 0 === L ? ge.selectableRowDisabled : L,
      B = n.selectableRowsComponent,
      V = void 0 === B ? ge.selectableRowsComponent : B,
      Y = n.selectableRowsComponentProps,
      U = void 0 === Y ? ge.selectableRowsComponentProps : Y,
      q = n.onRowExpandToggled,
      K = void 0 === q ? ge.onRowExpandToggled : q,
      J = n.onSelectedRowsChange,
      Q = void 0 === J ? ge.onSelectedRowsChange : J,
      X = n.expandableIcon,
      Z = void 0 === X ? ge.expandableIcon : X,
      ee = n.onChangeRowsPerPage,
      te = void 0 === ee ? ge.onChangeRowsPerPage : ee,
      ne = n.onChangePage,
      oe = void 0 === ne ? ge.onChangePage : ne,
      re = n.paginationServer,
      ie = void 0 === re ? ge.paginationServer : re,
      ae = n.paginationServerOptions,
      le = void 0 === ae ? ge.paginationServerOptions : ae,
      de = n.paginationTotalRows,
      se = void 0 === de ? ge.paginationTotalRows : de,
      ce = n.paginationDefaultPage,
      ue = void 0 === ce ? ge.paginationDefaultPage : ce,
      pe = n.paginationResetDefaultPage,
      fe = void 0 === pe ? ge.paginationResetDefaultPage : pe,
      he = n.paginationPerPage,
      we = void 0 === he ? ge.paginationPerPage : he,
      ve = n.paginationRowsPerPageOptions,
      me = void 0 === ve ? ge.paginationRowsPerPageOptions : ve,
      be = n.paginationIconLastPage,
      xe = void 0 === be ? ge.paginationIconLastPage : be,
      ye = n.paginationIconFirstPage,
      Re = void 0 === ye ? ge.paginationIconFirstPage : ye,
      Se = n.paginationIconNext,
      Ee = void 0 === Se ? ge.paginationIconNext : Se,
      Pe = n.paginationIconPrevious,
      ke = void 0 === Pe ? ge.paginationIconPrevious : Pe,
      Oe = n.paginationComponent,
      He = void 0 === Oe ? ge.paginationComponent : Oe,
      _e = n.paginationComponentOptions,
      Ae = void 0 === _e ? ge.paginationComponentOptions : _e,
      Ie = n.responsive,
      ze = void 0 === Ie ? ge.responsive : Ie,
      Me = n.overflowY,
      De = void 0 === Me ? ge.overflowY : Me,
      Le = n.overflowYOffset,
      je = void 0 === Le ? ge.overflowYOffset : Le,
      Ne = n.progressPending,
      We = void 0 === Ne ? ge.progressPending : Ne,
      Be = n.progressComponent,
      Ge = void 0 === Be ? ge.progressComponent : Be,
      Ve = n.persistTableHead,
      Ye = void 0 === Ve ? ge.persistTableHead : Ve,
      Ue = n.noDataComponent,
      qe = void 0 === Ue ? ge.noDataComponent : Ue,
      $e = n.disabled,
      Ke = void 0 === $e ? ge.disabled : $e,
      Je = n.noTableHead,
      Qe = void 0 === Je ? ge.noTableHead : Je,
      Xe = n.noHeader,
      Ze = void 0 === Xe ? ge.noHeader : Xe,
      et = n.fixedHeader,
      tt = void 0 === et ? ge.fixedHeader : et,
      nt = n.fixedHeaderScrollHeight,
      ot = void 0 === nt ? ge.fixedHeaderScrollHeight : nt,
      rt = n.pagination,
      it = void 0 === rt ? ge.pagination : rt,
      at = n.subHeader,
      lt = void 0 === at ? ge.subHeader : at,
      dt = n.subHeaderAlign,
      st = void 0 === dt ? ge.subHeaderAlign : dt,
      ct = n.subHeaderWrap,
      pt = void 0 === ct ? ge.subHeaderWrap : ct,
      ft = n.subHeaderComponent,
      yt = void 0 === ft ? ge.subHeaderComponent : ft,
      Ct = n.noContextMenu,
      Rt = void 0 === Ct ? ge.noContextMenu : Ct,
      St = n.contextMessage,
      Et = void 0 === St ? ge.contextMessage : St,
      Pt = n.contextActions,
      kt = void 0 === Pt ? ge.contextActions : Pt,
      Ot = n.contextComponent,
      Ht = void 0 === Ot ? ge.contextComponent : Ot,
      Ft = n.expandableRows,
      _t = void 0 === Ft ? ge.expandableRows : Ft,
      It = n.onRowClicked,
      zt = void 0 === It ? ge.onRowClicked : It,
      Mt = n.onRowDoubleClicked,
      Dt = void 0 === Mt ? ge.onRowDoubleClicked : Mt,
      Lt = n.sortIcon,
      jt = void 0 === Lt ? ge.sortIcon : Lt,
      Nt = n.onSort,
      Wt = void 0 === Nt ? ge.onSort : Nt,
      Vt = n.sortFunction,
      Yt = void 0 === Vt ? ge.sortFunction : Vt,
      Ut = n.sortServer,
      qt = void 0 === Ut ? ge.sortServer : Ut,
      $t = n.expandableRowsComponent,
      Kt = void 0 === $t ? ge.expandableRowsComponent : $t,
      Jt = n.expandableRowDisabled,
      Qt = void 0 === Jt ? ge.expandableRowDisabled : Jt,
      Xt = n.expandableRowsHideExpander,
      Zt = void 0 === Xt ? ge.expandableRowsHideExpander : Xt,
      en = n.expandOnRowClicked,
      tn = void 0 === en ? ge.expandOnRowClicked : en,
      nn = n.expandOnRowDoubleClicked,
      on = void 0 === nn ? ge.expandOnRowDoubleClicked : nn,
      rn = n.expandableRowExpanded,
      an = void 0 === rn ? ge.expandableRowExpanded : rn,
      ln = n.expandableInheritConditionalStyles,
      dn = void 0 === ln ? ge.expandableInheritConditionalStyles : ln,
      sn = n.defaultSortFieldId,
      cn = void 0 === sn ? ge.defaultSortFieldId : sn,
      un = n.defaultSortAsc,
      pn = void 0 === un ? ge.defaultSortAsc : un,
      fn = n.clearSelectedRows,
      gn = void 0 === fn ? ge.clearSelectedRows : fn,
      hn = n.conditionalRowStyles,
      wn = void 0 === hn ? ge.conditionalRowStyles : hn,
      vn = n.theme,
      mn = void 0 === vn ? ge.theme : vn,
      bn = n.customStyles,
      xn = void 0 === bn ? ge.customStyles : bn,
      yn = n.direction,
      Cn = void 0 === yn ? ge.direction : yn,
      Rn = e.useMemo(function () {
    return function (e) {
      return e.map(function (e, t) {
        var n = _l(_l({}, e), {
          sortable: e.sortable || !!e.sortFunction || void 0
        });

        return e.id || (n.id = t + 1), n;
      });
    }(d);
  }, [d]),
      Sn = (void 0 === (o = pn) && (o = !1), o ? "asc" : "desc"),
      En = e.useMemo(function () {
    return function (e, t) {
      if (void 0 !== typeof e) return t.find(function (t) {
        return t.id === e;
      });
    }(cn, Rn);
  }, [Rn, cn]),
      Pn = {
    allSelected: !1,
    rows: [],
    selectedCount: 0,
    selectedRows: [],
    selectedColumn: En || {
      name: ""
    },
    sortDirection: Sn,
    currentPage: ue,
    rowsPerPage: we,
    selectedRowsFlag: !1,
    contextMessage: ge.contextMessage
  },
      kn = e.useReducer(C, Pn),
      On = kn[0],
      Hn = On.rowsPerPage,
      Fn = On.rows,
      _n = On.currentPage,
      Tn = On.selectedRows,
      An = On.allSelected,
      In = On.selectedCount,
      zn = On.selectedColumn,
      Mn = On.sortDirection,
      Dn = kn[1],
      Ln = le.persistSelectedOnSort,
      jn = void 0 !== Ln && Ln,
      Nn = le.persistSelectedOnPageChange,
      Wn = void 0 !== Nn && Nn,
      Bn = !(!ie || !Wn && !jn),
      Gn = it && !We && i.length > 0,
      Vn = He || Tt,
      Yn = e.useMemo(function () {
    return function (e, t) {
      void 0 === e && (e = {}), void 0 === t && (t = "default");
      var n,
          o = Gt[t] ? t : "default";
      return Bt({
        table: {
          style: {
            color: (n = Gt[o]).text.primary,
            backgroundColor: n.background.default
          }
        },
        tableWrapper: {
          style: {
            display: "table"
          }
        },
        header: {
          style: {
            fontSize: "22px",
            color: n.text.primary,
            backgroundColor: n.background.default,
            minHeight: "56px",
            paddingLeft: "16px",
            paddingRight: "8px"
          }
        },
        subHeader: {
          style: {
            backgroundColor: n.background.default,
            minHeight: "52px"
          }
        },
        head: {
          style: {}
        },
        headRow: {
          style: {
            backgroundColor: n.background.default,
            minHeight: "56px",
            borderBottomWidth: "1px",
            borderBottomColor: n.divider.default,
            borderBottomStyle: "solid"
          },
          denseStyle: {
            minHeight: "32px"
          }
        },
        headCells: {
          style: {
            fontSize: "12px",
            fontWeight: 500,
            color: n.text.primary,
            paddingLeft: "16px",
            paddingRight: "16px"
          },
          activeSortStyle: {
            color: n.text.primary,
            "&:focus": {
              outline: "none"
            },
            "&:hover:not(:focus)": {
              color: n.sortFocus.default
            }
          },
          inactiveSortStyle: {
            "&:focus": {
              outline: "none",
              color: n.sortFocus.default
            },
            "&:hover": {
              color: n.sortFocus.default
            }
          }
        },
        contextMenu: {
          style: {
            backgroundColor: n.context.background,
            fontSize: "18px",
            fontWeight: 400,
            color: n.context.text,
            paddingLeft: "16px",
            paddingRight: "8px",
            transform: "translate3d(0, -100%, 0)",
            transitionDuration: "125ms",
            transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
            willChange: "transform"
          },
          activeStyle: {
            transform: "translate3d(0, 0, 0)"
          }
        },
        cells: {
          style: {
            paddingLeft: "16px",
            paddingRight: "16px",
            wordBreak: "break-word"
          }
        },
        rows: {
          style: {
            fontSize: "13px",
            color: n.text.primary,
            backgroundColor: n.background.default,
            minHeight: "48px",
            "&:not(:last-of-type)": {
              borderBottomStyle: "solid",
              borderBottomWidth: "1px",
              borderBottomColor: n.divider.default
            }
          },
          denseStyle: {
            minHeight: "32px"
          },
          selectedHighlightStyle: {
            "&:nth-of-type(n)": {
              color: n.selected.text,
              backgroundColor: n.selected.default,
              borderBottomColor: n.background.default
            }
          },
          highlightOnHoverStyle: {
            color: n.highlightOnHover.text,
            backgroundColor: n.highlightOnHover.default,
            transitionDuration: "0.15s",
            transitionProperty: "background-color",
            borderBottomColor: n.background.default,
            outlineStyle: "solid",
            outlineWidth: "1px",
            outlineColor: n.background.default
          },
          stripedStyle: {
            color: n.striped.text,
            backgroundColor: n.striped.default
          }
        },
        expanderRow: {
          style: {
            color: n.text.primary,
            backgroundColor: n.background.default
          }
        },
        expanderCell: {
          style: {
            flex: "0 0 48px"
          }
        },
        expanderButton: {
          style: {
            color: n.button.default,
            fill: n.button.default,
            backgroundColor: "transparent",
            borderRadius: "2px",
            transition: "0.25s",
            height: "100%",
            width: "100%",
            "&:hover:enabled": {
              cursor: "pointer"
            },
            "&:disabled": {
              color: n.button.disabled
            },
            "&:hover:not(:disabled)": {
              cursor: "pointer",
              backgroundColor: n.button.hover
            },
            "&:focus": {
              outline: "none",
              backgroundColor: n.button.focus
            },
            svg: {
              margin: "auto"
            }
          }
        },
        pagination: {
          style: {
            color: n.text.secondary,
            fontSize: "13px",
            minHeight: "56px",
            backgroundColor: n.background.default,
            borderTopStyle: "solid",
            borderTopWidth: "1px",
            borderTopColor: n.divider.default
          },
          pageButtonsStyle: {
            borderRadius: "50%",
            height: "40px",
            width: "40px",
            padding: "8px",
            margin: "px",
            cursor: "pointer",
            transition: "0.4s",
            color: n.button.default,
            fill: n.button.default,
            backgroundColor: "transparent",
            "&:disabled": {
              cursor: "unset",
              color: n.button.disabled,
              fill: n.button.disabled
            },
            "&:hover:not(:disabled)": {
              backgroundColor: n.button.hover
            },
            "&:focus": {
              outline: "none",
              backgroundColor: n.button.focus
            }
          }
        },
        noData: {
          style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: n.text.primary,
            backgroundColor: n.background.default
          }
        },
        progress: {
          style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: n.text.primary,
            backgroundColor: n.background.default
          }
        }
      }, e);
    }(xn, mn);
  }, [xn, mn]),
      Un = e.useMemo(function () {
    return Kt;
  }, [Kt]),
      qn = e.useMemo(function () {
    return _l({}, "auto" !== Cn && {
      dir: Cn
    });
  }, [Cn]),
      $n = function $n(e) {
    Dn(e);
  },
      Kn = function Kn(e) {
    Dn(e);
  },
      Jn = e.useCallback(function (e, t) {
    return zt(e, t);
  }, [zt]),
      Qn = e.useCallback(function (e, t) {
    return Dt(e, t);
  }, [Dt]),
      Xn = function Xn(e) {
    return Dn({
      type: "CHANGE_PAGE",
      page: e,
      paginationServer: ie,
      visibleOnly: z,
      persistSelectedOnPageChange: Wn
    });
  },
      Zn = e.useMemo(function () {
    if (it && !ie) {
      var e = _n * Hn,
          t = e - Hn;
      return Fn.slice(t, e);
    }

    return Fn;
  }, [_n, it, ie, Fn, Hn]);

  if (it && !ie && Fn.length > 0 && 0 === Zn.length) {
    var eo = w(Fn.length, Hn),
        to = v(_n, eo);
    Xn(to);
  }

  At(function () {
    Q({
      allSelected: An,
      selectedCount: In,
      selectedRows: Tn
    });
  }, [In]), At(function () {
    oe(_n, se || Fn.length);
  }, [_n]), At(function () {
    te(Hn, _n);
  }, [Hn]), At(function () {
    Wt(zn, Mn);
  }, [zn, Mn]), At(function () {
    Xn(ue);
  }, [ue, fe]), At(function () {
    if (it && ie && se > 0) {
      var e = w(se, Hn),
          t = v(_n, e);
      _n !== t && Xn(t);
    }
  }, [se]), e.useEffect(function () {
    Dn({
      type: "UPDATE_ROWS",
      rows: (null == En ? void 0 : En.selector) ? g(i, En.selector, Sn, Yt) : i
    });
  }, [i]), e.useEffect(function () {
    Dn({
      type: "CLEAR_SELECTED_ROWS",
      selectedRowsFlag: gn
    });
  }, [gn]), e.useEffect(function () {
    if (D) {
      var e = Fn.filter(function (e) {
        return D(e);
      });
      Dn({
        type: "SELECT_MULTIPLE_ROWS",
        keyField: h,
        selectedRows: e,
        rows: Fn,
        mergeSelections: Bn
      });
    }
  }, [Fn]);
  var no = z ? Zn : Fn,
      oo = Wn || A;
  return e.createElement(t.ThemeProvider, {
    theme: Yn
  }, !Ze && e.createElement(ut, {
    title: c,
    actions: p,
    showMenu: !Rt,
    selectedCount: In,
    direction: Cn,
    contextActions: kt,
    contextComponent: Ht,
    contextMessage: Et
  }), lt && e.createElement(gt, {
    align: st,
    wrapContent: pt
  }, yt), e.createElement(wt, _l({
    responsive: ze,
    overflowYOffset: je,
    overflowY: De
  }, qn), e.createElement(mt, null, We && !Ye && e.createElement(vt, null, Ge), e.createElement(N, {
    disabled: Ke,
    className: "rdt_Table",
    role: "table"
  }, !Qe && (!!Ye || Fn.length > 0 && !We) && e.createElement(W, {
    className: "rdt_TableHead",
    role: "rowgroup"
  }, e.createElement(G, {
    className: "rdt_TableHeadRow",
    role: "row",
    dense: k,
    disabled: We || 0 === Fn.length
  }, H && (oo ? e.createElement($, {
    style: {
      flex: "0 0 48px"
    }
  }) : e.createElement(Te, {
    allSelected: An,
    selectedRows: Tn,
    selectableRowsComponent: V,
    selectableRowsComponentProps: U,
    selectableRowDisabled: j,
    rowData: no,
    keyField: h,
    mergeSelections: Bn,
    onSelectAllRows: function onSelectAllRows(e) {
      Dn(e);
    }
  })), _t && !Zt && e.createElement(bt, null), Rn.map(function (t) {
    return e.createElement(Fe, {
      key: t.id,
      column: t,
      rows: Fn,
      pagination: it,
      paginationServer: ie,
      persistSelectedOnSort: jn,
      selectableRowsVisibleOnly: z,
      selectedColumn: zn,
      sortFunction: Yt,
      sortDirection: Mn,
      sortIcon: jt,
      sortServer: qt,
      onSort: $n
    });
  }))), !Fn.length && !We && e.createElement(xt, null, qe), We && Ye && e.createElement(vt, null, Ge), !We && Fn.length > 0 && e.createElement(ht, {
    fixedHeader: tt,
    fixedHeaderScrollHeight: ot,
    hasOffset: De,
    offset: je,
    className: "rdt_TableBody",
    role: "rowgroup"
  }, Zn.map(function (t, n) {
    var o,
        r = (void 0 === (o = t[h]) && (o = ""), "number" == typeof o || o && 0 !== o.length ? t[h] : n),
        i = x(t, Tn, h),
        a = !!(_t && an && an(t)),
        l = !!(_t && Qt && Qt(t));
    return e.createElement(Ce, {
      id: r,
      key: r,
      keyField: h,
      row: t,
      columns: Rn,
      selectableRows: H,
      expandableRows: _t,
      expandableIcon: Z,
      highlightOnHover: R,
      pointerOnHover: E,
      dense: k,
      expandOnRowClicked: tn,
      expandOnRowDoubleClicked: on,
      expandableRowsComponent: Un,
      expandableRowsHideExpander: Zt,
      defaultExpanderDisabled: l,
      defaultExpanded: a,
      expandableInheritConditionalStyles: dn,
      conditionalRowStyles: wn,
      rowCount: Fn.length,
      rowIndex: n,
      selected: i,
      selectableRowsHighlight: _,
      selectableRowsComponent: V,
      selectableRowsComponentProps: U,
      selectableRowDisabled: j,
      striped: b,
      onRowExpandToggled: K,
      onRowClicked: Jn,
      onRowDoubleClicked: Qn,
      onSelectedRow: Kn
    });
  }))))), Gn && e.createElement("div", null, e.createElement(Vn, {
    onChangePage: Xn,
    onChangeRowsPerPage: function onChangeRowsPerPage(e) {
      var t = w(se || Zn.length, e),
          n = v(_n, t);
      ie || Xn(n), Dn({
        type: "CHANGE_ROWS_PER_PAGE",
        page: n,
        rowsPerPage: e
      });
    },
    rowCount: se || Fn.length,
    currentPage: _n,
    rowsPerPage: Hn,
    direction: Cn,
    paginationRowsPerPageOptions: me,
    paginationIconLastPage: xe,
    paginationIconFirstPage: Re,
    paginationIconNext: Ee,
    paginationIconPrevious: ke,
    paginationComponentOptions: Ae
  })));
});
exports.STOP_PROP_TAG = "allowRowEvents", exports.createTheme = function (e, t) {
  return void 0 === e && (e = "default"), Gt[e] = Bt(Gt.default, t || {}), Gt[e];
}, exports.default = Vt, exports.defaultThemes = Gt;